<dx-button [text]="boosterLayer.boosterDetails.id?'Change Booster':'Select Booster'" (onClick)="changeBooster()">
</dx-button>
<div class="pcc-field">
  <div class="pcc-field-label">Booster</div>
  <div class="pcc-field-text-value">
    <dx-text-box [(value)]="boosterLayer.boosterName" readOnly="true" style="background:#EAF4F5;border:none">
    </dx-text-box>
  </div>
</div>
<div class="pcc-field-error">
  {{getError([error.boosters,boosterNumber-1,error.booster])}}
</div>
<div class="pcc-field">
  <div class="pcc-field-label">Limit Rotational Speed</div>
  <div class="pcc-field-text-value">
    <dx-check-box [(value)]="boosterLayer.boosterDetails.limitRotationalSpeed"
      (onValueChanged)="toggleChangeRotationalSpeed()"></dx-check-box>
  </div>
</div>
<div *ngIf="boosterLayer.boosterDetails.limitRotationalSpeed" style="padding-left:10px">
  <lib-number-field [quantity]="quantity.FREQUENCY" [label]="'Maximum Rotational Speed'"
    [(value)]="boosterLayer.boosterDetails.userMaximumFrequency" [error]="" (valueChange)="announceChange()">
  </lib-number-field>
</div>
<div class="pcc-field">
  <div class="pcc-field-label">Change Initial Rotational Speed</div>
  <div class="pcc-field-text-value">
    <dx-check-box [(value)]="boosterLayer.boosterDetails.changeInitialFrequency"
      (onValueChanged)="toggleChangeInitialFrequency()"></dx-check-box>
  </div>
</div>
<div *ngIf="boosterLayer.boosterDetails.initialFrequency!=-1" style="padding-left:10px">
  <lib-number-field [quantity]="quantity.FREQUENCY" [label]="'Initial Rotational Speed'"
    [(value)]="boosterLayer.boosterDetails.initialFrequency" [error]="" (valueChange)="announceChange()">
  </lib-number-field>
</div>
<div class="pcc-field">
  <div class="pcc-field-label">Number in Parallel</div>
  <div class="pcc-field-value">
    <dx-number-box [(value)]="boosterLayer.numberOfBoostersInParallel" [showSpinButtons]="true"
      [showClearButton]="false" (onValueChanged)="announceChange()" [min]="0.1" [max]="100">
    </dx-number-box>
  </div>
</div>
<div class="pcc-field-error">
  {{getError([error.boosters,boosterNumber-1,error.boosterparallel])}}
</div>
<!-- <dx-button text="Change Drive" (onClick)="changeDrive()"></dx-button> -->
<div class="pcc-field">
  <div class="pcc-field-label">Drive</div>
  <div class="pcc-field-text-value">
    <dx-text-box [value]="boosterLayer.boosterDetails.driveName" readOnly="true" style="background:#EAF4F5;border:none">
    </dx-text-box>
  </div>
</div>
<div class="pcc-field">
  <div class="pcc-field-label" style="font-weight: bold;">Outlet Pipework</div>
</div>
<lib-pipework #pipework [(pipes)]="boosterLayer.pipework"
  [fields]="['bends','flexible','length','parallel','section','xdim1','xdim2']"
  [errors]="getError([error.boosters,boosterNumber-1,error.pipe])" (listChanged)="changePipework($event)"
  (pipeClick)="clickPipe($event)" style="background: white;"></lib-pipework>
<div class="pcc-field-error">
  {{getError([error.boosters,boosterNumber-1,error.pipework])}}
</div>